import DashboardEmptyStateCard from '../../DashboardEmptyStateCard';
import UserIcon from '@/public/images/dashboard/user.svg';
import Trans from '@/components/shared/Trans';
import translations from '../../Dashboard.trans.json';

function PendingContactEmptyState() {
  return (
    <DashboardEmptyStateCard
      icon={UserIcon}
      title={Trans(translations, 'HereYouWillSeeYourUnattendedContacts')}
    />
  );
}

export default PendingContactEmptyState;
